import {
  LuBuilding2,
  LuCircleAlert,
  LuCircleCheck,
  LuFilePenLine,
} from 'react-icons/lu';
import './style.css';
import '../ProjectTasks/style.css';

const ProjectAbout = ({ data }) => {
  if (!data) return null;
  const [intro, problem] = data.paragraphs || [];

  if (data.bodyOnly) {
    return (
      <section className="project-about project-case-card">
        <h2 className="project-case-card__title">{data.title}</h2>
        <ul className="project-about__body project-tasks__list">
          {(data.paragraphs || []).map((paragraph) => (
            <li className="project-tasks__item" key={paragraph}>
              <LuCircleCheck />
              <span>{paragraph}</span>
            </li>
          ))}
        </ul>
      </section>
    );
  }

  return (
    <section className="project-about project-case-card">
      <h2 className="project-case-card__title">{data.title}</h2>

      <div className="project-about__intro">
        <span className="project-case-icon project-about__icon">
          <LuBuilding2 />
        </span>
        <p className="project-case-card__text">
          {intro}
        </p>
      </div>

      <div className="project-case-card__divider" />

      <div className="project-about__intro">
        <span className="project-case-icon project-about__icon">
          <LuCircleAlert />
        </span>
        <p className="project-case-card__text">
          {problem}
        </p>
      </div>

      <div className="project-case-card__divider" />

      <p className="project-case-card__text">
        {data.goalLead}
      </p>

      <ul className="project-about__list">
        {(data.goals || []).map((goal) => (
          <li key={goal} className="project-about__item">
            <LuCircleCheck />
            <span>{goal}</span>
          </li>
        ))}
      </ul>

      <div className="project-about__note">
        <LuFilePenLine className="project-about__note-icon" aria-hidden="true" />
        <p>{data.note}</p>
      </div>
    </section>
  );
};

export default ProjectAbout;
